import { Button, Result } from 'antd';

export const ErrorFallback = () => {
  return (
    <Result
      status="500"
      title="500"
      subTitle="Desculpe, algo deu errado."
      extra={
        <Button
          type="primary"
          onClick={() => window.location.assign(window.location.origin)}
          data-testid="goHome"
        >
          Voltar para início
        </Button>
      }
    />
  );
};
